<template>
	<div class="content container">
		<loader-component />
	</div>
</template>

<script setup lang="ts">
import LoaderComponent from '@/components/LoaderComponent.vue'
import { useAuthStore } from '@/stores/auth'
import { onMounted } from 'vue'

const authStore = useAuthStore()
// authStore.login()
onMounted(async () => {
	await authStore.login()
	await authStore.pollSubStatus()
})
</script>
